/**
 * @file dadata-address.ts
 * @description Подсказка адреса DaData: тип ответа и разбор (phase19.12).
 *
 * Формат снят с фактического использования в `AddressEditDialog`: сервер
 * отдаёт `{ suggestions: [...] }` в исходном виде DaData.
 */

/** Подсказка DaData (нужные нам поля). */
export interface DadataAddrSuggestion {
  value: string;
  unrestricted_value?: string;
  data: {
    postal_code?: string;
    region_with_type?: string;
    city?: string;
    city_with_type?: string;
    settlement?: string;
    settlement_with_type?: string;
    street_with_type?: string;
    house?: string;
    geo_lat?: string;
    geo_lon?: string;
  };
}

/** Типы населённых пунктов, которые встречаются в сохранённом адресе. */
const CITY_PREFIX = /^(г|город|пгт|рп|с|село|д|деревня|ст|станица)\.?\s+/iu;

/**
 * Город из уже сохранённой строки адреса — нужен, чтобы сузить поиск ПВЗ
 * до открытия подсказок. Не нашли — ничего страшного, ищем без города.
 */
export function cityFromAddressLine(address: string): string | null {
  const parts = address
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length === 0) return null;
  const typed = parts.find((p) => CITY_PREFIX.test(p));
  if (typed) return typed.replace(CITY_PREFIX, "").trim() || null;
  return parts.length === 1 ? (parts[0] ?? null) : null;
}

/**
 * Название населённого пункта без типа («Челябинск», а не «г Челябинск») —
 * справочник СДЭК ищет именно по чистому названию.
 */
export function suggestionCityName(s: DadataAddrSuggestion): string | null {
  const raw = s.data.city ?? s.data.settlement ?? null;
  if (raw) return raw;
  const withType = s.data.city_with_type ?? s.data.settlement_with_type ?? null;
  if (!withType) return null;
  // «г Челябинск» / «пгт Роза» → отбрасываем тип перед названием.
  return withType.replace(/^[а-яё.]+\s+/iu, "").trim() || null;
}
